<template>
  <!-- 可删除操作 -->
  <div class="item-in" v-if="showType == 'in'">
    <!-- 顶部评星 -->
    <div class="item-header">
      <div class="rate-block">
        <p>2020-03-03</p>
        <van-rate size="12" v-model="info.rate" color="#ffd21e" void-icon="star" readonly allow-half void-color="#eee" />
      </div>
      <van-icon class="r-icon" name="delete-o" @click="deleteComment(info, ind)" />
    </div>
    <!-- 商品 -->
    <div class="img-text-row" v-for="(ite, ind) in info.product" :key="ind">
      <van-image class="row-goods-img" :src="ite.imageUrl" />
      <div class="row-goods-info">
        <p class="row-goods-name">{{ ite.name }}</p>
        <p class="row-goods-price">¥ {{ ite.price }}</p>
      </div>
    </div>
    <!-- 评论 -->
    <div class="comment-text"> {{info.comment}} </div>
    <!-- 评论图 -->
    <div class="img-block">
      <van-image class="img" v-for="(itImg, inImg) in info.imgList" :key="inImg" @click="imagePreview(info.imgList,inImg)" :src="itImg" />
    </div>
  </div>

  <!-- 纯展示 -->
  <div class="item-on" v-else>
    <!-- 顶部评星 -->
    <div class="item-header">
      <div class="user-block">
        <van-image class="user-img van-hairline--surround" round fit="cover" :src="info.userImg" />
        <div class="user-rate">
          <p>{{info.userName}}
            <van-rate size="12" v-model="info.rate" color="#ffd21e" void-icon="star" readonly allow-half void-color="#eee" />
          </p>
          <p class="sku">{{info.sku || '默认'}}</p>
        </div>
      </div>
      <p class="r-time">{{info.time}}</p>
    </div>
    <!-- 评论 -->
    <div class="comment-text"> {{info.comment}} </div>
    <!-- 评论图 -->
    <div class="img-block">
      <van-image class="img" v-for="(itImg, inImg) in info.imgList" :key="inImg" @click="imagePreview(info.imgList,inImg)" :src="itImg" />
    </div>
  </div>

</template>

<script>
import { ImagePreview } from 'vant'
export default {
  name: "imgTextRow",
  props: {
    showType: {
      type: String,
      default: 'in'  //row column
    },
    info: {
      type: Object,
      default: {}  //row column
    },
    ind: {
      type: Number,
      default: 0 //row column
    },

  },
  components: {},
  data() {
    return {
      ss: "",
    };
  },
  created() { },
  mounted() { },
  methods: {
    deleteComment(info, ind) {

      this.$dialog.confirm({
        message: '是否确认删除该评论？',
        confirmButtonText: '删除',
        cancelButtonText: '再想想',
      })
        .then(() => {
          // on confirm
          this.$emit('delete', info, ind);

        })
        .catch(() => {
          // on cancel

        });
    },
    imagePreview(list, index) {
      ImagePreview({ //图片预览
        images: list, //需要预览的图片 URL 数组
        showIndex: true, //是否显示页码
        loop: false, //是否循环播放
        startPosition: index, //图片预览起始位置索引
        closeable: true, //是否显示关闭图标
        // showIndicators: true, //	是否显示轮播指示器
      })
    }
    // goProductDetails(){
    //    this.$router.push({ name:'product-details',
    //    query:{ }
    //    });
    // }
  },
};
</script>

<style lang="scss" scoped>
.item-in {
  margin: 15px 0;
  background: #ffffff;
  box-shadow: 0px 2px 5px rgba(120, 132, 158, 0.06);
  border-radius: 5px;
  .item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 10px 0;
    .rate-block {
      text-align: left;
      p {
        font-size: 9px;
        font-family: Source Han Sans CN;
        color: #999999;
      }
    }
    .r-icon {
      font-size: 16px;
    }
  }
  // 横向
  .img-text-row {
    // width: 100%;
    margin: 10px;
    background: #fafafa;
    box-shadow: 0px 2px 2px rgba(69, 79, 99, 0.06);
    opacity: 1;
    border-radius: 3px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .row-goods-img {
      width: 45px;
      height: 45px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .row-goods-info {
      width: 270px;
      height: 100%;
      // padding: 5px 0;
      text-align: left;
      //  background-color: paleturquoise;
      .row-goods-name {
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        letter-spacing: 1px;
        display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        overflow: hidden; /*超出的文本隐藏*/
        text-overflow: ellipsis; /* 溢出用省略号*/
        -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }

      .row-goods-price {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ff5000;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  // 评价内容
  .comment-text {
    padding: 10px;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #2a2e43;
    letter-spacing: 2px;
    text-align: left;
    text-transform: capitalize;
    // text-indent: 15px;
  }
  // 图片
  .img-block {
    // background-color: #eee;
    font-size: 12px;
    line-height: 20px;

    display: flex;
    flex-wrap: wrap;
    .img {
      width: 98px;
      height: 98px;
      margin: 0 0 15px 15px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.item-on {
  margin: 15px 0;
  background: #ffffff;
  box-shadow: 0px 2px 5px rgba(120, 132, 158, 0.06);
  border-radius: 5px;
  .item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 10px 0;
    .user-block {
      display: flex;
      flex-wrap: wrap;
      .user-img {
        width: 28px;
        height: 28px;
      }
      .user-rate {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      p {
        text-align: left;
        font-size: 12px;
        font-family: Source Han Sans CN;
        color: #999999;
        display: inline-block;
        font-size: 12px;
        transform: scale(0.9);
        -webkit-transform: scale(0.9);
        -moz-transform: scale(0.9);
      }
      .sku {
        display: inline-block;
        font-size: 12px;
        transform: scale(0.8);
        -webkit-transform: scale(0.8);
        -moz-transform: scale(0.8);
      }
    }
    .r-time {
      font-size: 9px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 15px;
      color: #999999;
    }
  }

  // 评价内容
  .comment-text {
    padding: 10px;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #2a2e43;
    letter-spacing: 2px;
    text-align: left;
    text-transform: capitalize;
    // text-indent: 15px;
  }
  // 图片
  .img-block {
    // background-color: #eee;
    font-size: 12px;
    line-height: 20px;

    display: flex;
    flex-wrap: wrap;
    .img {
      width: 98px;
      height: 98px;
      margin: 0 0 15px 15px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
